import type React from "react"
import { Trans } from "react-i18next"
import { Link } from "react-router-dom"

const Page404: React.FC = () => (
  <section className="flex items-center h-full p-16 dark:text-gray-100">
    <div className="container flex flex-col items-center justify-center px-5 mx-auto my-8">
      <div className="max-w-md text-center">
        <h2 className="mb-8 font-extrabold text-9xl dark:text-gray-600">
          <span className="sr-only">
            <Trans i18nKey="page404.error_sr" />
          </span>
          404
        </h2>
        <p className="text-2xl font-semibold md:text-3xl">
          <Trans i18nKey="page404.title" />
        </p>
        <p className="mt-4 mb-8 dark:text-gray-400">
          <Trans i18nKey="page404.description" />
        </p>

        <Link
          className="px-8 py-3 font-semibold rounded dark:bg-violet-400 dark:text-gray-900"
          to="/"
        >
          <Trans i18nKey="page404.back_home" />
        </Link>
      </div>
    </div>
  </section>
)

export default Page404
